var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2629 4.58383L4.36336 14.4833C3.97283 14.8738 3.97283 15.507 4.36336 15.8975C4.75388 16.2881 5.38705 16.2881 5.77757 15.8975L15.6771 5.99804C16.0676 5.60752 16.0676 4.97435 15.6771 4.58383C15.2865 4.1933 14.6534 4.1933 14.2629 4.58383Z",
    fill: "#F1416C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15.6769 14.4826L5.77742 4.58308C5.38689 4.19256 4.75373 4.19256 4.36321 4.58308C3.97268 4.97361 3.97268 5.60677 4.36321 5.9973L14.2627 15.8968C14.6532 16.2873 15.2864 16.2873 15.6769 15.8968C16.0674 15.5063 16.0674 14.8731 15.6769 14.4826Z",
    fill: "#F1416C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.52439aaf569e2fd2fb66511acd1310c7.svg";
export { ForwardRef as ReactComponent };